// import { useEffect } from 'react';
import { priceFormat } from 'util/prices';
import useProductCard from 'newHooks/useProductCard';
import { repareImage } from 'newFunctions/repareDataService';
import arrow from 'assets/img/select-arrow-open.svg';
import ProductModal from 'newComponents/ProductsModal/ProductTC';
import ProductsSuccessAdd from 'newComponents/ProductsModal/ProductSuccessAdd';
import { useState , useEffect } from 'react';
import ModalProductSimple from 'newComponents/ProductsModal/ProductSimple';
import styles from '../styles.module.sass'


const CardProduct = (props) => {

    const {
        item,
        modalNormalProduct = false
    } = props

    const {
        producto,
        image,
        addMore,
        removeGift,
        emptyGift,
        IsGiftTC,
        amount,
        productTC,
        successUpdate,
        clickAddProduct,
        clickAddProductTC,
        clickModalProduct,
        removeProduct,
        updateCant,
        sendCant,
        moreCant,
        minCant
    } = useProductCard({item})

    const [errorProduct, setErrorProduct] = useState(false)
    const [ showModal, setShowModal ] = useState(false)

    const handleClose = () => {
        clickModalProduct( {showModal: false} )
    }

    const handleCloseModal = () => {
        setShowModal(false)
    }

    const clickProduct = () => {
        if(!modalNormalProduct){
            clickAddProduct({cant: 1})
        }else{
            setShowModal(true)
        }
    }
    
    const clickAceptProduct = () => {
        clickAddProduct({cant: 1})
    }

    const resettUrl = () => {
        setErrorProduct(false)
    }

    const isMobile = 'desktop'

    


    useEffect(()=>{
        if(successUpdate){
            setShowModal(false)
            setErrorProduct(successUpdate)
        }
    },[ successUpdate ])

    return(
        <>
            <article className={styles?.cardProduct} data-type={producto?.id}>
                
                {emptyGift
                    ?
                        <div className={styles?.soldOut}> Agotado</div>
                    : null
                }
                
                <img src={repareImage(image)} alt={producto?.title} className={!emptyGift ? styles?.imageProduct : `${styles?.imageProduct} ${styles?.disabled}`} />
                
                <div className={styles?.contProductInt}>
                    <p className={styles?.title}>{producto?.title}</p>

                    <div className={styles?.contPrices}>

                        <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                    </div>
                    {addMore && !IsGiftTC 
                        ?
                            <div className={styles?.contInput}>
                                <input 
                                    name={`${producto?.id}_product`} 
                                    min="1" 
                                    max="22"
                                    step="1" 
                                    placeholder="" 
                                    maxLength="100" 
                                    type="number"
                                    onChange={updateCant}
                                    onBlur={sendCant}
                                    value={amount} 
                                    disabled={producto?.stock >= 1 ? null : 'disabled'}
                                />
                                <div className={styles?.contBtnsUpdate}>
                                    <img onClick={moreCant} className={styles?.topArrow} src={arrow} alt="Incrementar" aria-hidden="true" />
                                    <img onClick={minCant} className={styles?.bottomArrow} src={arrow} alt="Restar" aria-hidden="true" />
                                </div>
                            </div>
                        : null
                    }
                    <div>
                        {!addMore && !removeGift && ! emptyGift && !IsGiftTC ? <div className="btn secondaryButton btn-block" onClick={clickProduct} aria-hidden="true" >Agregar</div> : null}
                        {!addMore && !removeGift && ! emptyGift && IsGiftTC ? <div className="btn secondaryButton btn-block"  onClick={() => clickModalProduct( { productVariant: producto, showModal: true} )} aria-hidden="true" >Agregar</div> : null}
                        {removeGift ? <div className="btn underlineButton btn-block" onClick={removeProduct} aria-hidden="true" >Eliminar</div> : null }
                        {emptyGift ? <div className="btn secondaryButton disabled btn-block">Agregar</div> : null }
                    </div>
                </div>
            </article>

            <ProductModal
                modalTC
                handleClose={handleClose}
                isMobile={isMobile}
                title={isMobile === 'desktop' ? 'Promociones' : 'Promociones Sanborns'} 
                product={productTC}
                clickAddProduct={clickAddProductTC}
                image
            />

            {showModal
                ? 
                    <ModalProductSimple
                        producto={producto} 
                        handleCloseModal={handleCloseModal} 
                        clickAceptProduct={clickAceptProduct} 
                        isMobile={isMobile}
                        title={isMobile === 'desktop' ? 'Promociones' : 'Promociones Sanborns'} 
                        image
                    />
                : null 
            }

            {errorProduct
                ?
                    <ProductsSuccessAdd
                        successStore={errorProduct}
                        setSuccessStore={setErrorProduct}
                        resettUrl={resettUrl}
                        typeModal="agregasRegalos"
                    />
                : null
            }
        </>
    )
}



export default CardProduct